import React from "react";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  return (
    <a
      href="https://wa.me/919643572870?text=Hello%20K%20%26%20K%20Associates%2C%20I%27d%20like%20a%20legal%20consultation."
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute right-full top-1/2 -translate-y-1/2 mr-3 px-4 py-2 bg-ink text-white text-[11px] tracking-[0.2em] uppercase opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
        Chat with us
      </span>
      <div className="w-14 h-14 bg-brand text-white flex items-center justify-center shadow-lg hover:bg-brand-dark transition-all hover:scale-105 ring-1 ring-white/10">
        <MessageCircle className="w-6 h-6" strokeWidth={1.5} />
      </div>
    </a>
  );
}
